export default function PerformThreatAssessmentDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  bcpDataService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleFormSubmit = _handleFormSubmit;

  _activate();

  /** *********************************
   * Event Handlers
   */

  function _handleFormSubmit() {
    if (vm.saveType === 'saveAndClose' && $scope.performBCPThreatAssessmentForm.$invalid) {
      return false;
    }
    loaderService.showViewLoader = true;
    return bcpDataService.saveThreats(vm.assessmentThreats).then((response) => {
      loaderService.showViewLoader = false;
      if (!response.data) {
        const msg = 'Error occurred while saving the Threat Assessment.';
        alerts.error(msg);
        return Promise.reject(new Error(msg));
      }
      alerts.success('The BCP Threat Assessment has been saved successfully.');
      $rootScope.$broadcast('refreshBCPAssessments');
      $rootScope.$broadcast('refreshNotifications');
      if (vm.saveType === 'saveAndClose') {
        return _closeDialog();
      }
      return Promise.resolve();
    });
  }

  function _handleCloseDialog() {
    return _closeDialog();
  }

  /** *********************************
   * Private Functions
   */

  function _activate() {
    if (vm.assessmentThreats) {
      return bcpDataService.getThreats(vm.assessmentId).then((response) => {
        vm.assessmentThreats = response.data.result;
        loaderService.showViewLoader = false;
      });
    }
    loaderService.showViewLoader = false;
    return Promise.resolve();
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.bcp.performThreatAssessmentDialog);
  }
}

PerformThreatAssessmentDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'ssDialogService',
  'loaderService',
  'bcpDataService'
];
